// -- External libraries
import { mergeProps } from 'solid-js'

export const useMenuMoleculeComponentController = (props) => {
    const defaultProps = {}
    const mergedProps = mergeProps(defaultProps, props)

    // `location` used to be returned here — the bare global, i.e. `window.location`. Nothing
    // consumed it (its only reader was the commented-out block in the view), and referencing it made
    // this molecule throw `ReferenceError: location is not defined` the moment it rendered on a
    // server, which the prerendered location pages now do.
    return {
        mergedProps,
    }
}
